import { changeModelValues } from '../../../../helpers/change-model-values'

export default class AlLandingpageEditorComponentController {

    constructor($injector, $scope) {
        this.injector = $injector;
        this.scope = $scope;
        this.translate = this.injector.get('$translate');
        this.navService = this.injector.get('NavService');
        this.acl = this.injector.get('Acl');
        this.guestlistActionService = this.injector.get('GuestlistActionService');
        this.log = this.injector.get('$log');
        this.api = this.injector.get('$http');
        this.userStore = this.injector.get('Users');
        this.angularState = this.injector.get('$state');

        this.studioEnabled = _.get(this.userStore, 'state.company.settings.lp-api.studio_used', false);
        this.centerStageEnabled = _.get(this.userStore, 'state.company.settings.lp-api.center_stage_enabled', false);

        this.state = {};
        this.maxCustomFieldCounts = {
            contact: 40,
            rsvp: 40
        };

        this.definitionFields = [
            'registration_fields',
            'registration_guest_fields',
            'representative_fields',
            'recommendations_fields',
        ];

        this._resetState();
        this._updateTabs();

        this._updateView(this.studioEnabled ? 'studio' : 'form');
        this._prepareContactCustomFieldDefinitions();
        this._initWatchers();
    }

    // Public callable functions
    updateModelValues(updatedValues) {
        const model = {...this.state.model};

        changeModelValues(model, updatedValues)

        this._updateState({
            ...this.state,
            model
        });

        if (this.onModelUpdate) {
            this.onModelUpdate({newData: model});
        }
    }

    handleEnabledFieldsUpdate(newFieldList, blockGlobalUpdate) {
        this._updateState({
            ...this.state,
            enabledFields: _.cloneDeep(newFieldList)
        });


        this._updateState({
            ...this.state,
            model: {
                ...this.state.model,
                settings: {
                    ...this.state.model.settings,
                    enabled_fields: _.cloneDeep(this.state.enabledFields)
                }
            }
        });

        if (this.onModelUpdate) {
            this.onModelUpdate({newData: this.state.model});
        }
    }

    handleCustomFieldChange(action, group, definition, number) {
        const newCustomFieldDefinitions = _.cloneDeep(this.state.customFieldDefinitions.definitions);

        switch (action) {
            case 'update':
                if (!this._checkIfCustomFieldExists(group, number)) {
                    return;
                }
                _.set(newCustomFieldDefinitions, `${group}.${number}`, AlLandingpageEditorComponentController._cleanUpCustomFieldDefinition(definition));
                break;
            case 'delete':
                if (!this._checkIfCustomFieldExists(group, number)) {
                    return;
                }
                delete newCustomFieldDefinitions[group][number];
                let enabledFields = _.cloneDeep(this.state.enabledFields);
                const indexOfSelectedCustomField = enabledFields.indexOf(`${group}.custom_${number}`);
                if (indexOfSelectedCustomField !== -1) {
                    delete enabledFields[indexOfSelectedCustomField];
                }
                this.handleEnabledFieldsUpdate(enabledFields);
                break;
            case 'add':
                const newNumber = this._findNextCustomFieldNumberForGroup(group);
                _.set(newCustomFieldDefinitions, `${group}.${newNumber}`, AlLandingpageEditorComponentController._cleanUpCustomFieldDefinition(definition));
                break;
        }

        this._updateState({
            ...this.state,
            customFieldDefinitions: {
                ...this.state.customFieldDefinitions,
                definitions: newCustomFieldDefinitions
            }
        });

        this._updateCustomFieldAvailability();
        this._updateAvailableFieldsByCurrentCustomFields();
        this._updateCustomFieldsOnModel();
    }


    // Private callable functions
    _findNextCustomFieldNumberForGroup(group) {
        for (let i = 1; i <= this.maxCustomFieldCounts[group]; i++) {
            const definition = _.get(this.state.customFieldDefinitions.definitions, `${group}.${i}`);
            if (!definition || _.isEmpty(definition)) {
                return i;
            }
        }

        return null;
    }

    _updateAvailableFieldsByCurrentCustomFields() {
        const customFieldRegex = /^(rsvp|contact)\.custom_([0-9]{1,2})$/,
            newAvailableFields = _.cloneDeep(this.state.availableFields);

        _.each(newAvailableFields, (field, slug) => {
            if (customFieldRegex.test(slug)) {
                const regexParts = customFieldRegex.exec(slug);
                if (!_.has(this.state.customFieldDefinitions.definitions, `${regexParts[1]}.${regexParts[2]}`) || _.isUndefined(_.get(this.state.customFieldDefinitions.definitions, `${regexParts[1]}.${regexParts[2]}`, undefined))) {
                    delete newAvailableFields[slug];
                } else {
                    newAvailableFields[slug] = this._createFieldFromCustomDefinition(_.get(this.state.customFieldDefinitions.definitions, `${regexParts[1]}.${regexParts[2]}`))
                }
            }
        });

        _.each(this.state.customFieldDefinitions.definitions, (fields, group) => {
            _.each(fields, (fieldDefinition, fieldKey) => {
                const fieldSlug = `${group}.custom_${fieldKey}`;
                if (!newAvailableFields[fieldSlug]) {
                    newAvailableFields[fieldSlug] = this._createFieldFromCustomDefinition(fieldDefinition);
                }
            })
        });

        this._updateState({
            ...this.state,
            availableFields: newAvailableFields
        });
    }

    _createFieldFromCustomDefinition(customFieldDefinition) {
        customFieldDefinition = _.cloneDeep(customFieldDefinition);

        const fieldToFill = {
            default_label: customFieldDefinition.name,
            group: 'customs'
        };
        switch (customFieldDefinition.type) {
            case 'select':
            case 'multi_select':
                fieldToFill.enum = {};
                _.each(customFieldDefinition.enum, (val) => {
                    fieldToFill.enum[val] = val;
                });
            case 'textbox':
                fieldToFill.type = 'string';
                fieldToFill.multiline = false;
                break;
            case 'textarea':
                fieldToFill.type = 'string';
                fieldToFill.multiline = true;
                break;
            case 'decimal':
                fieldToFill.type = 'float';
                break;
            case 'boolean':
                fieldToFill.type = 'bool';
                break;
            case 'media_image':
                fieldToFill.type = 'image';
                break;
            case 'media_file':
                fieldToFill.type = 'file';
                break;
            case 'color_code_select':
                fieldToFill.type = 'color-codes';
                fieldToFill.enum = {};
                _.each(customFieldDefinition.enum, (val) => {
                    fieldToFill.enum[val.label] = val;
                });
                break;
            default:
            case 'integer':
            case 'datetime':
            case 'date':
                fieldToFill.type = customFieldDefinition.type;
                break;

        }

        return fieldToFill;
    }

    _checkIfCustomFieldExists(group, number) {
        if (_.has(this.state.customFieldDefinitions, `definitions.${group}.${number}`) && _.isObject(_.get(this.state.customFieldDefinitions, `definitions.${group}.${number}`))) {
            return true;
        }

        this.log.info('Custom field not exists', {group, number});
        return false;
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.guestlist;
        }, () => {
            if (this.guestlist) {
                this._loadAvailableFields();
                this._setupEnabledFields();
                this._prepareRsvpCustomFieldDefinitions();
            }
        });
        this.scope.$watch(() => {
            return this.externalViewTrigger;
        }, () => {
            if (_.isString(this.externalViewTrigger)) {
                const splittedExternalView = this.externalViewTrigger.split('::');

                if (splittedExternalView.length === 2) {
                    this._updateView(_.clone(splittedExternalView[0]), _.clone(splittedExternalView[1]));
                } else {
                    this._updateView(_.clone(splittedExternalView[0]));
                }
            }
        });
    }

    _updateState(newState) {
        this.state = newState;
        this._updateTabs();
        this.scope.$applyAsync();
    }

    _resetState() {
        this._updateState({
            currentView: 'general',
            currentAnchor: '',
            model: {},
            availableFields: {},
            customFieldDefinitions: {
                availability: {
                    contact: false,
                    rsvp: false
                },
                definitions: {
                    contact: {},
                    rsvp: {}
                }
            }
        });
    }

    _loadAvailableFields() {
        if (!this.guestlist) {
            return;
        }

        this.guestlistActionService.getAvailableFieldsForGuestlist(this.guestlist.id).then((availableFields) => {
            this._updateState({
                ...this.state,
                availableFields
            });
        }, (e) => {
            this.log('Error in loading available fields', error);
        });

    }

    _updateCustomFieldAvailability() {
        this._updateState({
            ...this.state,
            customFieldDefinitions: _.defaultsDeep({
                availability: {
                    rsvp: Object.keys(this.state.customFieldDefinitions.definitions.rsvp).length < this.maxCustomFieldCounts.rsvp,
                    contact: Object.keys(this.state.customFieldDefinitions.definitions.contact).length < this.maxCustomFieldCounts.contact
                }
            }, this.state.customFieldDefinitions)
        });
    }

    _prepareRsvpCustomFieldDefinitions() {
        const currentRsvpCustomFieldDefinitions = {};
        let fieldsAvailable = false;

        for (let i = 1; i <= this.maxCustomFieldCounts.rsvp; i++) {
            const fieldDefinition = _.get(this.guestlist, `custom_${i}_name`);
            if (fieldDefinition && _.isObject(fieldDefinition) && Object.keys(fieldDefinition).length > 0 && fieldDefinition.type) {
                fieldDefinition.global = false;
                currentRsvpCustomFieldDefinitions[i] = AlLandingpageEditorComponentController._cleanUpCustomFieldDefinition(fieldDefinition);
            } else {
                fieldsAvailable = true;
            }
        }

        this._updateState({
            ...this.state,
            customFieldDefinitions: _.defaultsDeep({
                availability: {
                    rsvp: Object.keys(currentRsvpCustomFieldDefinitions).length < this.maxCustomFieldCounts.rsvp
                },
                definitions: {
                    rsvp: currentRsvpCustomFieldDefinitions
                }
            }, this.state.customFieldDefinitions)
        });
    }

    _prepareContactCustomFieldDefinitions() {
        this.api.get('auth/profile?include=company').then((response) => {
            const usersStore = this.injector.get('Users');
            usersStore.commit('setCompany', _.get(response, 'data.data.company.data'));

            const company = usersStore.state.company;

            const currentContactCustomFieldDefinitions = {};
            let fieldsAvailable = false;
            for (let i = 1; i <= this.maxCustomFieldCounts.contact; i++) {
                const fieldDefinition = _.get(company, `custom_${i}_name`);
                if (fieldDefinition && _.isObject(fieldDefinition) && Object.keys(fieldDefinition).length > 0 && fieldDefinition.type) {
                    fieldDefinition.global = true;
                    currentContactCustomFieldDefinitions[i] = AlLandingpageEditorComponentController._cleanUpCustomFieldDefinition(fieldDefinition);
                } else {
                    fieldsAvailable = true;
                }
            }

            this._updateState({
                ...this.state,
                customFieldDefinitions: {
                    ...this.state.customFieldDefinitions,
                    availability: {
                        ...this.state.customFieldDefinitions.availability,
                        contact: Object.keys(currentContactCustomFieldDefinitions).length < this.maxCustomFieldCounts.contact
                    },
                    definitions: {
                        ...this.state.customFieldDefinitions.definitions,
                        contact: currentContactCustomFieldDefinitions
                    }
                }
            });
        });
    }

    _updateTabs() {
        let viewsToPerform = [
            {
                key: 'form',
                icon: 'file-spreadsheet',
                order: 10,
                anchors: [
                    {
                        key: 'type'
                    },
                    {
                        key: 'guests_of_guest',
                        accessor: () => {
                            return _.get(this.state.model, 'settings.enable_open_registration') || _.get(this.state.model, 'settings.enable_code_registration');
                        }
                    },
                    {
                        key: 'representative',
                        accessor: () => {
                            return _.get(this.state.model, 'settings.enable_open_registration') || _.get(this.state.model, 'settings.enable_code_registration');
                        }
                    },
                    {
                        key: 'recommendation',
                        accessor: () => {
                            return _.get(this.state.model, 'settings.enable_open_registration') || _.get(this.state.model, 'settings.enable_code_registration');
                        }
                    },
                    {
                        key: 'form_fields',
                        accessor: () => {
                            return _.get(this.state.model, 'settings.enable_open_registration') || _.get(this.state.model, 'settings.enable_code_registration');
                        }
                    },
                    {
                        key: 'develop_tools',
                        accessor: () => {
                            return _.get(this.state.model, 'settings.enable_open_registration') || _.get(this.state.model, 'settings.enable_code_registration');
                        }
                    },
                    {
                        key: 'registration_settings',
                        accessor: () => {
                            return _.get(this.state.model, 'settings.enable_open_registration') || _.get(this.state.model, 'settings.enable_code_registration');
                        }
                    }
                ]
            },
            {
                key: 'landing',
                icon: 'browser',
                order: 15,
                anchors: [
                    {
                        key: 'website'
                    },
                    {
                        key: 'alerts'
                    }
                ]
            },
            {
                key: 'studio',
                icon: 'browser',
                order: 20,
                accessor: () => this.studioEnabled,
                anchors: []
            },
            {
                key: 'center-stage',
                icon: 'browser',
                order: 25,
                accessor: () => this.centerStageEnabled,
                action: () => {
                    this.onExternalRouteStart();
                    this.angularState.go('app.guestlists.rsvps.center-stage', {
                        gid: this.guestlist.id
                    });
                },
                anchors: []
            },
            {
                key: 'domain',
                icon: 'sitemap',
                order: 30,
                anchors: []
            },
        ];

        viewsToPerform.sort((a, b) => {
            return a.order - b.order;
        });

        const tabsToSet = [];
        let currentTabEnabled = false;

        _.each(viewsToPerform, (tabInformation) => {
            if (tabInformation.accessor && !tabInformation.accessor()) {
                return;
            }

            if (tabInformation.key === this.state.currentView) {
                currentTabEnabled = true;
            }

            tabsToSet.push({
                label: this.translate.instant(`guestlists.editor.navigation.${tabInformation.key}.label`),
                active: (this.state.currentView === tabInformation.key),
                icon: tabInformation.icon,
                action: tabInformation.action ? tabInformation.action : () => this._updateView(tabInformation.key),
                subItems: (tabInformation.anchors && this.state.currentView === tabInformation.key) ? _.map(_.filter(tabInformation.anchors, (anchorInformation) => {
                    if (anchorInformation.key === 'develop_tools' && !this.acl.hasRight('guestlists::develop-tools')) {
                        return false;
                    }
                    if (_.isUndefined(anchorInformation.accessor) || !_.isFunction(anchorInformation.accessor)) {
                        return true;
                    }

                    return anchorInformation.accessor();
                }), (anchorInformation) => {
                    return {
                        label: this.translate.instant(`guestlists.editor.navigation.${tabInformation.key}.subItems.${anchorInformation.key}`),
                        active: false, //(this.state.currentView === tabInformation.key && this.state.currentAnchor === anchorInformation.key),
                        anchor: tabInformation.key + '_' + anchorInformation.key,
                        action: (event) => {
                            event.preventDefault();
                            this._updateView(tabInformation.key, anchorInformation.key)
                        }
                    }
                }) : []
            });
        });

        this.navService.setSideNavCustoms(tabsToSet);

        if (!currentTabEnabled) {
            tabsToSet[0].action();
        }
    }

    _updateView(newView, newAnchor) {
        this._updateState({
            ...this.state,
            currentView: newView,
            currentAnchor: newAnchor ? newAnchor : ''
        });

        let curCursor = 0;
        const scrollToAction = () => {
            const $elemToScrollTo = jQuery('#' + newView + '_' + newAnchor);
            if ($elemToScrollTo.length > 0) {
                jQuery('html, body').animate({scrollTop: $elemToScrollTo.offset().top - 114}, 200);
            } else if (curCursor++ < 100) {
                this.injector.get('$timeout')(() => {
                    scrollToAction();
                }, 0);
            }
        };

        if (newAnchor) {
            scrollToAction();
        } else {
            this.injector.get('$timeout')(() => {
                jQuery('html, body').animate({scrollTop: 0}, 200);
            }, 0);
        }
        this._updateTabs();
    }

    _updateCustomFieldsOnModel() {
        const newRsvpCustomFieldData = {};
        for (let i = 1; i <= this.maxCustomFieldCounts.rsvp; i++) {
            newRsvpCustomFieldData[`custom_${i}_name`] = null;
        }
        _.each(this.state.customFieldDefinitions.definitions.rsvp, (fieldInformation, fieldIndex) => {
            newRsvpCustomFieldData[`custom_${fieldIndex}_name`] = _.cloneDeep(fieldInformation);
        });

        this.updateModelValues(newRsvpCustomFieldData);

        const newContactCustomFieldData = {};
        for (let i = 1; i <= this.maxCustomFieldCounts.contact; i++) {
            newContactCustomFieldData[`custom_${i}_name`] = null;
        }
        _.each(this.state.customFieldDefinitions.definitions.contact, (fieldInformation, fieldIndex) => {
            newContactCustomFieldData[`custom_${fieldIndex}_name`] = _.cloneDeep(fieldInformation);
        });

        this.onContactCustomFieldUpdate({newFieldDefinitions: newContactCustomFieldData})
    }

    static _cleanUpCustomFieldDefinition(definition) {
        const allowedFields = [
            'name',
            'type',
            'global',
            'studio'
        ];

        switch (definition.type) {
            case 'select':
            case 'multi_select':
            case 'color_code_select':
                allowedFields.push('enum');
                break;
        }

        return _.pick(definition, allowedFields);
    }

    _setupEnabledFields() {
        this._updateState({
            ...this.state,
            enabledFields: _.cloneDeep(this.guestlist.settings.enabled_fields)
        });
    }
}

AlLandingpageEditorComponentController.$inject = [
    '$injector',
    '$scope'
];



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-landingpage-editor/controller.js